import React from "react";
import { Button, Icon, Loader } from "semantic-ui-react";
import ActivityCard from "./ActivityCard";
import Images from "../../../config/images";
import axios from "axios";
import { addNewDocument, docUploaded, fetchAddDocumentStatus, getPreSignedUrls } from "../../../apiCalls/MainFormRequests";
import { get } from "lodash";
import { HttpClient } from "../../../apiCalls/httpClient";
//import DropDown from "../../../commonComponents/dropDownCommon";
import DropDown from "../../../CBP_App/formComponents/dropDown";

class AddDocumentModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { files: [], fileInput: "", fileListDisplay: "", uploadedFiles: [], addingDocs: false, failedDocs: [] };
  }

  handleDocumentsSubmit = async () => {
    if(this.state.docType == ""){
      alert("Please select document type");
      return false;
    }
    try {
      let files = this.state.files;
      this.setState({ addingDocs: true, filesToAdd: this.state.files }, () => {
        this.fileUpload(files, this.props.shipmentId,this.props);
      });
    } catch (err) {
      console.error("err FILE UPLOAD", err);
    }
  };

  fileUpload = async (files, shipmentId, parentprops, docType = null, addDocNew = true) => {
    let uploadedFiles = [];
    let config = {
      headers: {
        "content-type": "multipart/form-data"
      },
    };
    const userBasicInfo = get(parentprops, "userBasicInfo", "");
    const documentType = docType ? docType : this.state.docType
    files.forEach((file, i) => {
      let bodyFormData = new FormData();
      bodyFormData.append("files", file);

      let fileSize = Math.floor(file.size/1000000); 
      if(fileSize>=10){
        getPreSignedUrls("", file.name).then((res)=>{
          let url = res?.data?.eventMessage?.url;
          this.uploadFileApi("put", url, documentType, uploadedFiles, shipmentId, addDocNew, config, bodyFormData, files, userBasicInfo, parentprops, i);
        });
      }else{
        this.uploadFileApi("post", `${window._env_.REACT_APP_SHIPMENT_MEDIA_URL}/${shipmentId}`, documentType, uploadedFiles, shipmentId, addDocNew, config, bodyFormData, files, userBasicInfo, parentprops)
      }   
  })
};
 
  uploadFileApi = (method, url, documentType, uploadedFiles, shipmentId, addDocNew, config, bodyFormData, files, userBasicInfo, parentprops, index) => {
    let clientMethod = method === "put" ? HttpClient.put : axios.post;
    return clientMethod(url, bodyFormData, config) 
        .then((response) => {
          let string = response?.data?.msg;
          let docName = "";
          if(string){
            string = string.split("[")[1];
            string = string.split("]")[0];
            uploadedFiles.push(string);
            docName = string;
          }else{
            uploadedFiles.push(files[index].name); 
            docName = files[index].name;
          }
          if (method === "put" || (addDocNew && (uploadedFiles.length - 1 === files.length - 1))) {
            addNewDocument(shipmentId, uploadedFiles, documentType, userBasicInfo)
              .then((res) => {
                if(documentType == 48){
                  docUploaded(shipmentId, "48", docName, 'IPAFF_DOC_UPLOADED');
                }
                let uploadId = get(res, "data.eventMessage.addDocumentObjectKey", "");
                this.interval = setInterval(() => {
                  fetchAddDocumentStatus(uploadId).then((res) => {
                    let statuses = get(res, "data.eventMessage", []);
                    const allSuccessful = (arr) => arr.every((elem) => elem.status === "SUCCESS");
                    const completeWithFailure = (arr) => arr.every((elem) => elem.status === "SUCCESS" || elem.status === "FAILURE");

                    if (allSuccessful(statuses)) {
                      clearInterval(this.interval);
                      parentprops.loadShipment && parentprops.loadShipment(false);
                      this.setState({ addingDocs: false }, () => {
                        parentprops.toggle && parentprops.toggle("addDocumentModal", false);
                      });
                      document.getElementById("file-input").classList.remove("HAS_CHANGE_SSS");
                    } else if (completeWithFailure(statuses)) {
                      clearInterval(this.interval);
                      let failedDocs = statuses.filter((doc) => doc.status === "FAILURE");
                      this.setState({ addingDocs: "error", failedDocs: failedDocs, files: this.state.filesToAdd.filter((file) => failedDocs.filter((failedDoc) => failedDoc.documentName === `${shipmentId}-${file.name}`)) });
                    }
                  });
                }, 3000);
              })
              .catch((err) => {
                this.setState({ addingDocs: "error", files: this.state.filesToAdd });
                console.error("ADD_DOCUMENT error", err);
              });
          }
        })
        .catch((err) => {
          console.error("error", err);
        });
  }

  appendFiles = () => {
    let newFiles = [];
    for (let i = 0; i < this.state.fileInput.files.length; i++) {
      newFiles.push(this.state.fileInput.files[i]);
    }
    this.setState({
      files: newFiles,
    });
  };

  componentDidMount() {
    this.setState(
      {
        docType: "",
        fileInput: document.getElementById("file-input"),
        fileListDisplay: document.getElementById("file-list-display"),
      },
      () => {
        if (document.getElementById("file-input").classList.contains("HAS_CHANGE_SSS")) return;
        this.state.fileInput.addEventListener(
          "change",
          function () {
            this.appendFiles();
          }.bind(this)
        );
        document.getElementById("file-input").classList.add("HAS_CHANGE_SSS");
      }
    );
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  createActivityCards = (docs) => {
    let results = [];
    if (docs) {
      docs.forEach((doc, i) => {
        results.push(
          <div key={i} className="blk" onClick={(e) => {}}>
            <ActivityCard title={doc.name} doc={null} openDoc={null} date={null} orderNumber={null} tagImage="document" buttonAvailable={false} />
          </div>
        );
      });
    }
    return results;
  };

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ addingDocs: false });
      this.props.toggle("addDocumentModal");
      document.getElementById("file-input").classList.remove("HAS_CHANGE_SSS");
    }
  };

  render() {
    let { docUploadInput } = this.props;
    let hasdocumentupload = !!docUploadInput;
    let whatttt = (this.props.docTypes||[]).sort((aaa, bbb) => (aaa?.shortLabel || "").localeCompare(bbb?.shortLabel || "")).map((aaaa) => {
      return { ...aaaa, value: aaaa.enum, id: aaaa.enum, description: `${aaaa.shortLabel} - ${aaaa.longLabel}` };
    });
    return (
      <div ref={this.setWrapperRef} className={"add-document-container"}>
        {(this.state.files.length > 0 || hasdocumentupload) && (
          <div>
            <label className="custom-file-upload add-documents">
              <img src={Images.file} alt="" />
              <title>
                Add More Documents<span>For this shipment</span>
              </title>
              <div className="new-docs">
                {this.state.addingDocs === "error" && <p>The following documents failed to upload:</p>}
                <span>{this.createActivityCards(this.state.files)}</span>
              </div>
              <div style={{"marginTop":"20px", "marginBottom":"20px"}}>
              <button style={{display:'none'}}>{/*fix it clicking the first button*/}</button>
              {hasdocumentupload && <div>
                <Button className="filterButton" style={{width:'100%'}}  onClick={()=>{
                  docUploadInput.value = ''
                  docUploadInput.click()}}>
                  Choose File
                </Button>
                <br/>
                <br/>
                </div>}

                <DropDown
                  lazyLoad={true}
                  hidePrefix={true}
                  inline
                  scrolling
                  selection
                  fluid
                  text={(()=>{
                    let currentDoc = whatttt.find(aaaa=>aaaa.id==this.state.docType);
                    if(currentDoc){
                      return `${currentDoc.shortLabel} - ${currentDoc.longLabel}`
                    }
                    return "Please Select"
                  })()}
                  upward={false}
                  handleFocus={(val)=>{
                    this.setState({"docTypeSelectorFocused": true})
                  }}
                  onBlur={(val)=>{
                    this.setState({"docTypeSelectorFocused": false})
                  }}
                  onChange={(newValue) => {
                    this.setState({"docTypeSelectorFocused": false})
                    this.setState({"docType": newValue})

                  }}
                  data={whatttt}
                />

                <br /><br />
                {this.state.docTypeSelectorFocused && <>
                  <br /><br />
                  <br /><br />
                  <br /><br />
                  <br /><br />
                  <br /><br />
                  <br /><br />
                </>}
               
              </div>
              {Boolean(this.state.files.length) && this.state.addingDocs === false ? (
                <Button className="filterButton" onClick={this.handleDocumentsSubmit}>
                  Upload Documents <Icon name="upload" />
                </Button>
              ) : this.state.addingDocs === true ? (
                <>
                  <Loader active inline size="mini" style={{ marginRight: "10px" }} /> {`Uploading document...`}
                </>
              ) : this.state.addingDocs === "error" ? (
                <Button className="filterButton" onClick={this.handleDocumentsSubmit}>
                  Try Again <Icon name="upload" />
                </Button>
              ) : null}
            </label>
          </div>
        )}
      </div>
    );
  }
}

export default AddDocumentModal;